import styles from 'css/src/components/public-pages/Title.module.scss';

import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import type { Document } from '@contentful/rich-text-types';

import { BUTTON_SIZES, PrimaryButton, SecondaryButton } from 'js/src/components/common/ui/Button';
import { addUtmParams } from 'js/src/libs/add-utm';
import type { ImmutableMap } from 'js/src/libs/consts';

type Props = {
    data: ImmutableMap<{
        title: string;
        subheading: Document;
        cta_url?: string;
        cta_text?: string;
        secondary_cta_url?: string;
        secondary_cta_text?: string;
    }>;
    bgColor: string;
};

const Title = React.memo(function Title({ data, bgColor }: Props) {
    let titleNode = null;
    if (data.get('title')) {
        titleNode = <h1 className="text-center">{data.get('title')}</h1>;
    }

    let subheadingNode = null;
    if (data.get('subheading')) {
        subheadingNode = (
            <h5 className="text-center">
                {documentToReactComponents(data.get('subheading').toJS())}
            </h5>
        );
    }

    const ctaUrl = data.get('cta_url');
    const ctaText = data.get('cta_text');
    const secondaryCtaUrl = data.get('secondary_cta_url');
    const secondaryCtaText = data.get('secondary_cta_text');

    let primaryCta = null;
    if (ctaUrl && ctaText) {
        const url = addUtmParams(ctaUrl, ctaText);
        primaryCta = (
            <PrimaryButton href={url} size={BUTTON_SIZES.LG} text={ctaText} className="m-l5-8" />
        );
    }

    let secondaryCta = null;
    if (secondaryCtaUrl && secondaryCtaText) {
        const url = addUtmParams(secondaryCtaUrl, secondaryCtaText);
        secondaryCta = (
            <SecondaryButton
                href={url}
                size={BUTTON_SIZES.LG}
                text={secondaryCtaText}
                className="m-l5-8"
            />
        );
    }

    const cta =
        primaryCta || secondaryCta ? (
            <>
                {primaryCta}
                {secondaryCta}
            </>
        ) : null;

    if (!subheadingNode && !titleNode) {
        return null;
    }

    return (
        <div
            className={`contentful-component ${styles['title']}`}
            style={{ backgroundColor: bgColor }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-sm-10 offset-sm-1">{titleNode}</div>
                </div>
                {subheadingNode && (
                    <div className="row">
                        <div className="col-sm-8 offset-sm-2">{subheadingNode}</div>
                    </div>
                )}
                {cta && (
                    <div className="row">
                        <div className="col-sm-10 offset-sm-1">
                            <div className="text-center mt-l5-24">{cta}</div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
});

export default Title;
